import { useContext } from 'react'
import InfoDialogContext from '../context/InfoDialogContext'

export default function useInfoDialog() {
    return useContext(InfoDialogContext)
}
